module.exports = __webpack_public_path__ + "img/New-Working-from-Office.f8a06830.png";